import { useCallback } from 'react'
import { ButtonV2 } from 'builder/components/Button'
import { useI18n } from 'builder/hooks/useI18n'
import { actions, AutoTailoringFromPublicJobBoardStep } from 'builder/modules/resumeEditor'
import { FetchStatuses } from 'builder/modules/constants'
import { useTailoredResumeEdit } from 'builder/components/AutoTailoring/OverviewModal/hooks/useTailoredResumeEdit'

export const FinnishTailoringButton = () => {
  const { i18n } = useI18n()

  const { getJobTrackingPath } = useTailoredResumeEdit()

  const handleFinishTailoring = useCallback(() => {
    actions.setAutoTailoringForPublicJobBoard({
      processingAutoTailoring: FetchStatuses.notAsked,
      step: AutoTailoringFromPublicJobBoardStep.finished,
    })
    window.location.href = getJobTrackingPath()
  }, [getJobTrackingPath])

  return (
    <ButtonV2 onClick={handleFinishTailoring}>
      {i18n.t(`builder.prefill_resume.auto_tailoring_view.header.finish_tailoring`)}
    </ButtonV2>
  )
}
